import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { i18n } from '../../../translate/i18n';
import { uniqueId } from 'lodash';
import filesize from "filesize";
import API from '../../../axios/api';
import axios from "axios";

import {
  IconButton, Paper, Typography, Divider, TextField, useMediaQuery, FormControlLabel, Switch,
  FormHelperText,
  Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import PhotoUpload from '../../../UI/PhotoUpload';

import ModalPhotoEditor from '../../../UI/PhotoEditor/ModalEditor';
import * as actions from "../../../store/actions";
import SpinnerOverlay from '../../../UI/SpinnerOverlay/SpinnerOverlay';

export default function MyAccount(props) {
  const dispatch = useDispatch();

  const matches = useMediaQuery('(min-width:1100px)');

  const [name, setName] = useState("");
  const [passwordCurrent, setPasswordCurrent] = useState('');
  const [passwordNew1, setPasswordNew1] = useState('');
  const [passwordNew2, setPasswordNew2] = useState('');
  const [profile, setProfile] = useState([])
  const [modalPhoto, setModalPhoto] = useState('');

  const [nameError, setNameError] = useState(false);
  const [nameFullError, setNameFullError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordNewError, setPasswordNewError] = useState(false);
  const [passwordMatchNewError, setPasswordMatchNewError] = useState(false);
  const [passwordLengthNewError, setPasswordLengthNewError] = useState(false);
  const [profileError, setProfileError] = useState(false);
  const [receiveAutomaticEmails, setReceiveAutomaticEmails] = useState(true);
  const [showServiceReportCoordinatesSwitch, setShowServiceReportCoordinatesSwitch] = useState(true);


  const [editName, setEditName] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [openModalAvatar, setOpenModalAvatar] = useState(false);

  const loading = useSelector(state => state.auth.loading);
  const nameFromRedux = useSelector(state => state.auth.name);
  const photoFromRedux = useSelector(state => state.auth.photo);
  const emailFromRedux = useSelector(state => state.auth.email);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const postChangeName = (body) => dispatch(actions.changeName(body))
  const postChangePassword = (body) => dispatch(actions.changePassword(body))
  const postChangeProfilePicture = (body) => dispatch(actions.changeProfilePicture(body))
  const postChangeReceiveAutomaticEmails = (body) => dispatch(actions.changeAutomaticEmails(body))
  const changeShowServiceReportCoordinates = (body) => dispatch(actions.changeShowServiceReportCoordinates(body))

  useEffect(() => {
    setName(nameFromRedux)
    if (photoFromRedux && photoFromRedux.url) {
      setProfile([photoFromRedux])
    }
    setReceiveAutomaticEmails(selectedAccess.receiveAutomaticEmails);
    if (selectedAccess.showServiceReportCoordinates !== undefined) {
      setShowServiceReportCoordinatesSwitch(selectedAccess.showServiceReportCoordinates)
    }
  }, [])

  const handleUploadPhoto = photo => {
    const uploadingFiles = photo.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      progress: 0,
      uploaded: false,
      error: false,
      url: null
    }))

    // setProfile(uploadingFiles)
    // uploadingFiles.forEach(processUpload);
    setModalPhoto(uploadingFiles[0]);
    setOpenModalAvatar(true);

  }

  const updateFile = (id, data) => {
    setProfile(prevUf => {
      return prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf)
    })
  };


  const processUpload = async uploadedFile => {

    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("photos/signurl", { file: payloadToSign }).then(signUrlRes => {
      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile._id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `profile/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType
        }

        API.post("photos", body)
          .then(response => {
            setProfileError(false);
            const { _id } = response.data;
            postChangeProfilePicture({ photo: _id }).then(resp => {
              updateFile(uploadedFile._id, {
                uploaded: true,
                _id: response.data._id,
                url: response.data.url,
              });
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true
            });
          });
      })
    })
  }

  const handleCloseModalAvatar = (file) => {
    let uploadedFile = [];
    if (file) {
      uploadedFile.push({
        file,
        id: uniqueId(),
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        fileType: file.type,
        progress: 0,
        uploaded: false,
        error: false,
        url: null
      });
      setProfile(uploadedFile)
      processUpload(uploadedFile[0])
    }
    setOpenModalAvatar(false);
  }


  const handleClickChangeName = (name) => {
    let hasError = false;
    if (!name) {
      setNameError(true);
      hasError = true;
    }

    if (name.split(" ").length < 2) {
      setNameFullError(true);
      hasError = true;
    }

    if (hasError) return;

    postChangeName({ name }).then(resp => {
      setEditName(false)
    })

  }

  const handleClickChangeReceiveAutomaticEmails = (checked) => {
    postChangeReceiveAutomaticEmails({ receiveAutomaticEmails: checked });
    setReceiveAutomaticEmails(checked);
  }

  const handleClickChangeShowServiceReportCoordinates = (checked) => {
    changeShowServiceReportCoordinates({ accessId: selectedAccess._id, showServiceReportCoordinates: checked });
    setShowServiceReportCoordinatesSwitch(checked);
  }
  
  const handleClickChangePassword = () => {
    let hasError = false;

    if (!passwordCurrent) {
      setPasswordError(true);
      hasError = true
    }

    if (passwordNew1 !== passwordNew2) {
      setPasswordMatchNewError(true);
      hasError = true
    }

    if (passwordNew1.length < 6) {
      setPasswordLengthNewError(true);
      hasError = true
    }

    if (hasError) return;

    postChangePassword({ oldPassword: passwordCurrent, newPassword: passwordNew1 }).then(resp => {
      setEditPassword(false)
    })
  }

  const handleCloseEmail = () => {
    setEditName(false);
    setName(nameFromRedux);
  };

  const handleClosePassword = () => {
    setEditPassword(false);
    setPasswordCurrent('');
    setPasswordNew1('');
    setPasswordNew2('');
  };

  return <>
    <ModalPhotoEditor
      selectedFile={modalPhoto}
      open={openModalAvatar}
      onClose={handleCloseModalAvatar}
      title={i18n.t('modalPhotoEditorUserMyAccount.title')}
    />
    {loading && <SpinnerOverlay />}
    <Paper style={styles.paper}>
      <div style={styles.title}>
        <Typography variant='h4'>{i18n.t('typoUserMyAccount.title')}</Typography>
      </div>
      <Divider />
      <div style={{ ...styles.container, flexDirection: matches ? 'row' : 'column' }}>
        <div style={styles.containerAvatar}>
          <PhotoUpload onUpload={handleUploadPhoto} photo={profile} enabled={true} rounded editIcon />
          {/* <PhotoBarUploading photo={profile} /> */}
          {profileError ? <Typography style={{ color: "#f44336" }}>{i18n.t('typoUserMyAccount.profileError')}</Typography> : null}
        </div>
        <div style={styles.containerInfos}>
          <div style={{ ...styles.listitem, padding: '20px 10px' }}>
            <Typography style={styles.label}>E-mail</Typography>
            <div style={styles.valueContainer}>
              <Typography style={styles.value}>{emailFromRedux}</Typography>
            </div>
          </div>
          <Divider />

          <div style={styles.listitem}>
            <Typography style={styles.label}>{i18n.t('typoUserMyAccount.name')}</Typography>
            <div style={styles.valueContainer}>
              {editName ?
                <div style={styles.itemContainer}>
                  <TextField
                    variant="standard"
                    value={name}
                    onChange={event => { setNameError(false); setNameFullError(false); return setName(event.target.value.toUpperCase()) }}
                    fullWidth
                    helperText={nameFullError && i18n.t('textFieldUserMyAccount.nameHelp')}
                    error={nameError || nameFullError} />
                  <IconButton onClick={() => handleClickChangeName(name)} size="large">
                    <DoneIcon style={styles.buttonDone} />
                  </IconButton>
                  <IconButton onClick={() => handleCloseEmail()} size="large">
                    <CloseIcon style={styles.buttonCancel} />
                  </IconButton>
                </div> :
                <div style={styles.itemContainer}>
                  <Typography style={styles.value}>{name}</Typography>
                  <IconButton onClick={() => setEditName(true)} size="large">
                    <EditIcon />
                  </IconButton>
                </div>
              }
            </div>
          </div>
          <Divider />
          <div style={styles.listitem}>
            <Typography style={styles.label}>{i18n.t('typoUserMyAccount.password')}</Typography>
            <div style={styles.valueContainer}>
              {editPassword ?
                <div style={styles.itemContainer}>
                  <div>
                    <TextField
                      variant="standard"
                      type="password"
                      label={i18n.t('textFieldUserMyAccount.password')}
                      margin='normal'
                      value={passwordCurrent}
                      onChange={event => { setPasswordError(false); return setPasswordCurrent(event.target.value) }}
                      fullWidth
                      error={passwordError} />
                    <TextField
                      variant="standard"
                      type="password"
                      label={i18n.t('textFieldUserMyAccount.passwordNew')}
                      margin='normal'
                      value={passwordNew1}
                      onChange={event => { setPasswordNewError(false); setPasswordLengthNewError(false); setPasswordMatchNewError(false); return setPasswordNew1(event.target.value) }}
                      fullWidth
                      error={passwordNewError || passwordLengthNewError}
                      helperText={passwordLengthNewError && i18n.t('textFieldUserMyAccount.passwordError')} />
                    <TextField
                      variant="standard"
                      type="password"
                      label={i18n.t('textFieldUserMyAccount.passwordNew2')}
                      margin='normal'
                      value={passwordNew2}
                      onChange={event => { setPasswordNewError(false); setPasswordMatchNewError(false); return setPasswordNew2(event.target.value) }}
                      fullWidth
                      error={passwordNewError}
                      helperText={setPasswordMatchNewError && i18n.t('textFieldUserMyAccount.PasswordNewError2')} />
                  </div>
                  <div style={styles.passwordButtonsContainer}>
                    <IconButton onClick={() => handleClickChangePassword()} size="large">
                      <DoneIcon style={styles.buttonDone} />
                    </IconButton>
                    <IconButton onClick={() => handleClosePassword()} size="large">
                      <CloseIcon style={styles.buttonCancel} />
                    </IconButton>
                  </div>
                </div> :
                <div style={styles.itemContainer}>
                  <Typography style={styles.value}>{'\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217'}</Typography>
                  <IconButton onClick={() => setEditPassword(true)} size="large">
                    <EditIcon />
                  </IconButton>
                </div>
              }
            </div>
          </div>
          <Divider />
        </div>
      </div>
      <div style={{ ...styles.title, marginTop: '20px' }}>
        <Typography variant='h4'>{i18n.t('typoUserMyAccount.config')}</Typography>
      </div>
      <Divider />
      <div style={{ ...styles.listitem, alignItems: 'flex-start' }}>
        <div style={styles.automaticEmailSwitchContainer}>
          <FormControlLabel
            control={
              <Switch
                checked={receiveAutomaticEmails}
                onChange={e => handleClickChangeReceiveAutomaticEmails(e.target.checked)}
              />
            }
          />
        </div>
        <Box>
          <Typography style={styles.switchlabel}>{i18n.t('typoUserMyAccount.label')}</Typography>
          <Typography style={styles.switchHelperText}>{i18n.t('typoUserMyAccount.automaticEmailsHelperTitle')}</Typography>
          <ul style={styles.switchHelperList}>
            <li><Typography style={styles.switchHelperText}>{i18n.t('typoUserMyAccount.automaticEmailsHelperWeeklyServicesReport')}</Typography></li>
            <li><Typography style={styles.switchHelperText}>{i18n.t('typoUserMyAccount.automaticEmailsHelperWeeklyActionsReport')}</Typography></li>
            <li><Typography style={styles.switchHelperText}>{i18n.t('typoUserMyAccount.automaticEmailsHelperActionCompleted')}</Typography></li>
            <li><Typography style={styles.switchHelperText}>{i18n.t('typoUserMyAccount.automaticEmailsHelperActionAssigned')}</Typography></li>
          </ul>
        </Box>
      </div>
      <div style={styles.listitem}>
        <div style={styles.automaticEmailSwitchContainer}>
          <FormControlLabel
            control={
              <Switch
                checked={showServiceReportCoordinatesSwitch}
                onChange={e => handleClickChangeShowServiceReportCoordinates(e.target.checked)}
              />
            }                    
          />
        </div>
        <Box>
          <Typography style={styles.switchlabel}>{i18n.t('typoUserMyAccount.coordinatesLabel')}</Typography>
        </Box>
      </div>
    </Paper >
  </>;
}

const styles = {
  paper: {
    padding: '30px',
  },
  title: {
    display: 'flex',
    marginBottom: '10px',
    fontWeight: 'bold',
  },

  container: {
    display: 'flex',
  },
  containerAvatar: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '20px',
    height: '235px',
    // border: '1px solid',
  },
  containerInfos: {
    width: '100%',
    marginTop: 20,
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listitem: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 10,
  },

  valueContainer: {
    width: '100%',
  },

  label: {
    fontWeight: 'bold',
    width: '30%',
  },
  switchlabel: {
    fontWeight: 'bold',
    width: '100%',
  },
  switchHelperText: {
    color: 'grey',
    fontSize: '0.8rem',
  },
  switchHelperList: {
    margin: 0,
    paddingLeft: 20,
    color: 'grey',
  },
  value: {
    color: 'grey',
  },
  avatar: {
    position: 'relative',
    width: 175,
    height: 175
  },
  buttonDone: {
    color: 'green',
  },
  buttonCancel: {
    color: 'red',
  },
  passwordButtonsContainer: {
    display: 'flex',
  },
  automaticEmailSwitchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  }
}
